import Big from 'big.js'

/**
 * Compute CBAM liability lower bound (base × (1 - lowPercentage)) using Big.js
 * to avoid IEEE-754 precision issues. Rounds to 2 decimal places for currency.
 *
 * @param baseLiabilityEuro - Base liability in EUR (e.g. from computeCbamLiabilityEuro)
 * @param lowPercentageAsDecimal - Low percentage as decimal (e.g. 0.1 for 10%)
 */
export function computeLiabilityLowerBound(
  baseLiabilityEuro: number,
  lowPercentageAsDecimal: number
): number {
  const base = new Big(baseLiabilityEuro)
  const factor = new Big(1).minus(lowPercentageAsDecimal)
  return base.times(factor).round(2, Big.roundHalfUp).toNumber()
}

/**
 * Compute CBAM liability upper bound (base × (1 + highPercentage)) using Big.js
 * to avoid IEEE-754 precision issues. Rounds to 2 decimal places for currency.
 *
 * @param baseLiabilityEuro - Base liability in EUR (e.g. from computeCbamLiabilityEuro)
 * @param highPercentageAsDecimal - High percentage as decimal (e.g. 0.15 for 15%)
 */
export function computeLiabilityUpperBound(
  baseLiabilityEuro: number,
  highPercentageAsDecimal: number
): number {
  const base = new Big(baseLiabilityEuro)
  const factor = new Big(1).plus(highPercentageAsDecimal)
  return base.times(factor).round(2, Big.roundHalfUp).toNumber()
}
